import type { ReactElement } from 'react';
import { FESTIVAL_ASSETS } from '../festival-assets';
import { SlideFrame } from './SlideFrame';

export const NORTHROP_WORDMARK_SRC = FESTIVAL_ASSETS.logoHorizontal;

export function TitleSlide(): ReactElement {
  return (
    <SlideFrame center festivalBackdrop>
      <div
        data-testid="festival-cover-circle"
        style={{
          position: 'relative',
          height: 972,
          aspectRatio: '1',
          borderRadius: '50%',
          background: 'var(--deck-circle)',
          color: 'var(--deck-card)',
        }}
      >
        <img
          src={NORTHROP_WORDMARK_SRC}
          alt="Northrop Festival"
          style={{
            position: 'absolute',
            left: '50%',
            top: '25%',
            width: '68%',
            height: 'auto',
            transform: 'translate(-50%, -50%)',
            filter: 'brightness(0) invert(1)',
          }}
        />
        <h1
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            width: '82%',
            transform: 'translate(-50%, -50%)',
            fontFamily: 'var(--font-display)',
            fontWeight: 500,
            fontSize: 58,
            color: 'var(--deck-card)',
            lineHeight: 'var(--leading-tight)',
            letterSpacing: '0.01em',
            margin: 0,
          }}
        >
          LEARN TO VIBE CODE!
        </h1>
        <p
          style={{
            position: 'absolute',
            left: '50%',
            top: '75%',
            width: '76%',
            transform: 'translate(-50%, -50%)',
            fontFamily: 'var(--font-display)',
            fontWeight: 500,
            fontSize: 29,
            lineHeight: 1.25,
            letterSpacing: '0.06em',
            whiteSpace: 'pre-line',
            margin: 0,
          }}
        >
          {'NICK BOEY\nAND\nTHE DIGITAL INNOVATION TEAM'}
        </p>
      </div>
    </SlideFrame>
  );
}
